/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const EXTRACTION_TYPES = ['word', 'phrase', 'idiom', 'chunk', 'phrasal_verb'] as const;
export const extractionTypeSchema = z.enum(EXTRACTION_TYPES);
export type IExtractionType = z.infer<typeof extractionTypeSchema>;
